import React from 'react';
import gifImage3 from '../assets/peng2.png';
import gifImage2 from '../assets/peng3.gif';


const WhoWeAre: React.FC = () => {
    return (
        <div
            className="flex flex-col relative md:flex-row items-center justify-center bg-orange-200 py-28 px-6 md:px-20 space-y-6 md:space-y-0 md:space-x-8 font-halo-dek">
            {/* Left Side - Image with Frame and Tag */}
            <div className="flex flex-col">
                <div className="relative">
                    <div className="border-8 border-white w-1/3 mx-auto  relative rounded-[12%] ">
                        <img
                            src={gifImage2}// Replace with your image path
                            alt="DUCK"
                            className="rounded-[10%] mx-auto"

                        />
                        {/* Frame Style */}
                        <div className="absolute inset-0 border-8 border-white rounded-[10%]"></div>
                    </div>
                    {/* Tag - About Us */}
                    <div
                        className="absolute text-black top-0 left-0 -mt-6 -ml-8 bg-orange-400 font-halo-dek font-bold px-4 py-1 rounded-full transform -rotate-12">
                        ABOUT US
                    </div>
                </div>

                {/* Right Side - Text Content */}
                <div className="text-center  text-black md:text-left space-y-4">
                    <h2 className="text-5xl font-extrabold">Who We Are</h2>
                    <p className="text-xl tracking-wide  font-medium">
                        We are Dark Pengu – the shadow of the pengu, the chaos in the huddle.

                        No fluff, no cute vibes. Just pure degen energy, dank memes, and the dark side of the waddle.

                        We don’t follow the light. We are the dark.
                        Believe in $DARKU.
                    </p>
                </div>
            </div>


            <div className=" rotate-[-3deg] h-16 bg-orange-300 absolute bottom-0 left-[-4%] w-[110%]"></div>
            <div className=" rotate-[-3deg] h-16 bg-orange-100 absolute bottom-[-54px] left-[-4%] w-[110%]"></div>
        </div>
    );
};

export default WhoWeAre;
